import React from 'react';
import { Button } from './ui/button';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <div className="bg-gradient-to-r from-purple-600 to-purple-500 text-white w-12 h-12 rounded-full font-bold text-lg flex items-center justify-center">
            Fi
          </div>
        </div>
        
        <nav className="hidden md:flex items-center gap-8">
          <a href="#home" className="text-gray-700 hover:text-purple-600 transition-colors font-medium">Home</a>
          <a href="#about" className="text-gray-700 hover:text-purple-600 transition-colors font-medium">About</a>
          <a href="#contact" className="text-gray-700 hover:text-purple-600 transition-colors font-medium">Contact</a>
          <a href="#blog" className="text-gray-700 hover:text-purple-600 transition-colors font-medium">Blog</a>
          <a href="#features" className="text-gray-700 hover:text-purple-600 transition-colors font-medium">Features</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
